var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-badge\n    text-center w-auto py-1 px-2.5 rounded-md\n    flex justify-center items-center text-sm text-EXPONDO-white h-7",class:_vm.badgeClass},[_c('span',[_vm._v(_vm._s(_vm.$t(_vm.badgeTranslationKey)))])])}
var staticRenderFns = []

export { render, staticRenderFns }